module.exports = __webpack_public_path__ + "media/highclass/service-appeals-pc-1a7b71c9.svg";